/**
 * surebetCalculatorBridge - Shared helpers to open the calculator from surebet rows
 */

/**
 * Build calculator modal payload from a surebet item and margin key
 * @param {Object} surebet - MarketsAnalysis item
 * @param {string} marginKey - Margin type key (e.g. margin1X2)
 * @returns {Object|null} Payload for CalculatorContext openModal, or null if invalid
 */
export const buildCalculatorPayloadFromSurebet = (surebet, marginKey) => {
  if (!surebet?.margins?.[marginKey]) {
    return null;
  }

  const marginData = surebet.margins[marginKey];

  return {
    event: surebet.event,
    marginKey,
    marginData,
    marketType: marginKey,
    odds: (marginData.coefficients || []).map(coef => ({
      bookmaker: coef.bookmaker,
      outcome: coef.type,
      value: String(coef.value ?? ''),
    })),
  };
};

/**
 * Open calculator modal via ref from a surebet row click
 * @param {Object} calculatorRef - React ref holding useCalculator() API
 * @param {Object} surebet - MarketsAnalysis item
 * @param {string} marginKey - Margin type key
 * @returns {boolean} Whether the modal was opened
 */
export const openCalculatorFromSurebet = (calculatorRef, surebet, marginKey) => {
  const calculatorData = buildCalculatorPayloadFromSurebet(surebet, marginKey);

  if (!calculatorData || !calculatorRef?.current?.actions?.openModal) {
    return false;
  }

  calculatorRef.current.actions.openModal(calculatorData);
  return true;
};
